import React, { Component } from "react";
import pubsub from "pubsub-js";
import { Checkbox, Skeleton } from "@mui/material/";
import { Dropdown, List, Modal } from "semantic-ui-react";
import { InputGroup, Input, Card, CardBody } from "reactstrap";
import { Button, Row, Col } from "reactstrap";
import { Redirect } from "react-router";
import { connect } from "react-redux";
import { Badge, Empty, Menu, Dropdown as DropdownAntd } from "antd";
import axios from "axios";
import ToggleState from "../Common/ToggleState";
import TriggerResize from "../Common/TriggerResize";
import ToggleFullscreen from "../Common/ToggleFullscreen";
import HeaderRun from "./Header.run";
import largeIMG from "./../../../resources/logo-xpdconnect-blanco.svg";
import smallIMG from "./../../../resources/icono-xpdconnect-blanco.svg";
import { Link, withRouter } from "react-router-dom";
import Authentication from "../../../../src/services/Authentication.js";
import { SetNewListGroups } from "./../../../state/actions/Header/";
import SessionStorage from "./../../../services/SessionStorage";
import { Services } from "../../../repositories/clients/Services";
import { Drawer } from "@material-ui/core";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { withStyles } from "@material-ui/core/styles";

import "./style.scss";
import { display } from "@mui/system";

import i18n from "../../../i18n";
import { withNamespaces } from "react-i18next";

const auth = new Authentication();
const session = new SessionStorage();

const styles = (theme) => ({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
  paper: {
    background: "white",
    // background: "#fefefec9"
  },
});

const iconSelect = {
  A: "icon-notification-alert",
  N: "icon-notifications-bell",
  M: "icon-notifications-bell",
};
const ROLES_WITH_EXTRA_INFO = ["1", "2", "3", "4"];

class Header extends Component {
  constructor(props) {
    super(props);
    i18n.changeLanguage(this.props.lang);
    this.state = {
      redirect: false,
      open: false,
      openselect: false,
      dataDrop: [],
      dataDrop1: [],
      notify: this.props.notify,
      nit: this.props.nit,
      clients: this.props.clients,
      lang: this.props.lang,
      checkAll: true,
      rolId: auth.getAuthentication("RoleId"),
      cout: 0,
      customHeight: window.innerHeight,
      openModal: false,
      openDrop: false,
      isMobil: false,
      collapsed: false,
      showAllBeforeNotify: false,
      isLoadingMoreBeforeNotify: false,
      showExtraInfo: ROLES_WITH_EXTRA_INFO.includes(
        auth.getAuthentication("RoleId"),
      ),
    };
  }
  componentDidMount() {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);

    const data = this.props.group_list;

    let cout = 0;
    data.map((e) => {
      e.data.map((f) => {
        f.hidden = false;
        if (f.check) {
          cout = cout + 1;
        }
        return f;
      });
      return e;
    });
    this.setState(
      {
        dataDrop: [...data] ? [...data] : [],
        dataDrop1: [...data] ? [...data] : [],
        cout,
        isMobil: isMobileDevice,
      },
      () => {},
    );
    HeaderRun();

    window.addEventListener("resize", this.updateDimensions);

    return () => {
      window.removeEventListener("resize", this.updateDimensions);
    };
  }

  componentWillUnmount() {
    if (this.beforeNotifyTimeout) {
      clearTimeout(this.beforeNotifyTimeout);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.notify !== this.props.notify) {
      this.setState({
        notify: this.props.notify,
        showAllBeforeNotify: false,
        isLoadingMoreBeforeNotify: false,
      });
    }
  }

  updateDimensions = () => {
    this.setState({ customHeight: window.innerHeight });
  };
  /*=============================================
    =            Handle Togle User Block         =
    =============================================*/
  toggleUserblock(e) {
    e.preventDefault();
    pubsub.publish("toggleUserblock");
  }

  normalize = (value) => (value ? value.toString().toLowerCase() : "");

  matchesSearch = (item, search) => {
    const text = search.toLowerCase();

    return (
      this.normalize(item.value).includes(text) ||
      this.normalize(item.NIT).includes(text) ||
      this.normalize(item.id).includes(text) ||
      this.normalize(item.OwnerTeam).includes(text)
    );
  };

  handleSearch = (event) => {
    const search = event.target.value;
    const haveSearch = search.length > 0;

    const dataDrop = this.state.dataDrop.map((group) => {
      const data = group.data.map((item) => ({
        ...item,
        hidden: haveSearch ? !this.matchesSearch(item, search) : false,
      }));

      return {
        ...group,
        data,
      };
    });

    this.setState({ dataDrop, search });
  };

  handleShowMoreBeforeNotify = () => {
    this.setState({ isLoadingMoreBeforeNotify: true });

    this.beforeNotifyTimeout = setTimeout(() => {
      this.setState({
        showAllBeforeNotify: true,
        isLoadingMoreBeforeNotify: false,
      });
    }, 2000);
  };

  handeInputData = (event) => {
    this.setState({ searchValue: event.target.value });
  };

  checkGroup = (index, all, uncheck) => {
    let newData = this.state.dataDrop;
    if (all) {
      if (uncheck) {
        newData[index].check = false;
        newData[index].data.map((e) => {
          e.check = false;
          return e;
        });
      } else {
        newData[index].check = true;
        newData[index].data.map((e) => {
          e.check = true;
          return e;
        });
      }
    } else {
      newData[index].check = !newData[index].check;
      newData[index].data.map((e) => {
        e.check = newData[index].check;
        return e;
      });
    }

    let cout = 0;
    newData.map((e) => {
      e.data.map((f) => {
        if (f.check) {
          cout = cout + 1;
        }
        return f;
      });
      return e;
    });

    this.setState({ dataDrop: newData, cout });
  };

  getCheck = async () => {
    let clientes = [];
    let NIT = [];
    this.state.dataDrop.map((e) => {
      e.data.map((f) => {
        if (f.check) {
          clientes.push(f.id);
          NIT.push(f.NIT);
        }
        f.hidden = false;
        return f;
      });
      return e;
    });
    this.setState({
      openDrop: false,
      openModal: false,
      // openselect: false,
      search: "",
      clientes,
      NIT,
    });
    session.updateItem("clients", JSON.stringify(clientes));
    session.updateItem("nit", JSON.stringify(NIT));
    session.updateItem("group_list", JSON.stringify(this.state.dataDrop));
    session.addItem("notify", JSON.stringify(this.state.notify));

    await this.props.SetNewListGroups({
      group_list: this.state.dataDrop,
      clients: clientes,
      nit: NIT,
      notify: this.state.notify,
      lang: this.state.lang,
    });

    this.props.changeProps();
  };

  change = () => {
    // this.setState({ openselect: false });
    this.setState({ openDrop: false, openModal: false });
  };

  checkClient = (index, ind) => {
    let newData = this.state.dataDrop;
    newData[index].data[ind].check = !newData[index].data[ind].check;
    if (!newData[index].data[ind].check) {
      newData[index].check = false;
    }
    let cout = 0;
    newData.map((e) => {
      e.data.map((f) => {
        if (f.check) {
          cout = cout + 1;
        }
        return f;
      });
      return e;
    });

    this.setState({ dataDrop: newData, cout });
  };

  checkAll = () => {
    if (!this.state.checkAll) {
      let newData = this.state.dataDrop;
      newData.map((e, index) => {
        this.checkGroup(index, true, false);
        return e;
      });
      this.setState({ checkAll: true });
    } else {
      let newData = this.state.dataDrop;
      newData.map((e, index) => {
        this.setState({ checkAll: false });
        this.checkGroup(index, true, true);
        return e;
      });
    }
  };

  getNotificationRedirectPath = (type, path, idMovimiento, idComment) => {
    if (type === "M") {
      return `${path}${idMovimiento}?nofify=true&idComment=${idComment}`;
    }

    return `${path}${idMovimiento}`;
  };

  getNotificationUpdateEndpoint = (type) => {
    if (type === "A" || type === "N") {
      return `${Services.ADMIN.path}alerts-notifications/updateViewNotification`;
    }

    return `${Services.ADMIN.path}mencion/updateView`;
  };

  redirectModule = async (idComment, idMovimiento, path, viewComment, type) => {
    const redirectPath = this.getNotificationRedirectPath(
      type,
      path,
      idMovimiento,
      idComment,
    );

    let { clients, nit, dataDrop } = this.state;

    if (viewComment === 0) {
      let UserId = auth.getAuthentication("dataUser");
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      let data = {
        CommentId: idComment,
        UserId,
        timezone,
        lang: this.props.lng,
      };

      try {
        const response = await axios.put(
          this.getNotificationUpdateEndpoint(type),
          data,
        );
        let newNotify = response.data.Notify;
        session.addItem("notify", JSON.stringify(newNotify));
        session.updateItem("clients", JSON.stringify(clients));
        session.updateItem("nit", JSON.stringify(nit));
        session.updateItem("group_list", JSON.stringify(dataDrop));

        this.setState(
          {
            notify: newNotify,
            open: false,
          },
          () => {
            this.props.SetNewListGroups({
              group_list: dataDrop,
              clients,
              nit,
              notify: newNotify,
              lang: this.state.lang,
            });
            this.props.history.push(redirectPath);
          },
        );
      } catch (error) {
        console.warn(error);
      }
    } else {
      this.setState({ open: false }, () => {
        this.props.history.push(redirectPath);
      });
    }
  };

  getNotify = () => {
    let { notify, showAllBeforeNotify, isLoadingMoreBeforeNotify } = this.state;
    const unreadNotify = notify.filter((item) => item.ReadComment === "0");
    const newNotify = unreadNotify.slice(0, 3);
    const newNotifyIds = new Set(
      newNotify.map((item) => `${item.CommentId || ""}-${item.RowId || ""}`),
    );
    const beforeNotify = notify.filter(
      (item) =>
        !newNotifyIds.has(`${item.CommentId || ""}-${item.RowId || ""}`),
    );
    const visibleBeforeNotify = showAllBeforeNotify
      ? beforeNotify
      : beforeNotify.slice(0, 10);
    const beforeNotifySkeleton = Array.from({ length: 3 }, (_, index) => (
      <div
        key={`before-notify-skeleton-${index}`}
        className="notification-skeleton-item"
      >
        <div className="notification-skeleton-icon">
          <Skeleton
            variant="circular"
            width={26}
            height={26}
            animation="wave"
          />
        </div>
        <div className="notification-skeleton-content">
          <Skeleton variant="text" width="55%" height={18} animation="wave" />
          <Skeleton variant="text" width="90%" height={16} animation="wave" />
        </div>
      </div>
    ));

    const renderNotifyItem = (e, index, isUnread) => (
      <Card
        key={`${e.CommentId || e.RowId || "notify"}-${index}`}
        className={`notification-item ${isUnread ? "notification-item-unread" : "notification-item-read"}`}
      >
        <CardBody
          onClick={() =>
            this.redirectModule(
              e.CommentId,
              e.RowId,
              e.Url,
              Number(e.ReadComment),
              e.Type,
            )
          }
          className="cardBodyNotify"
        >
          <div className="notification-item-layout">
            <div
              className={`notification-item-icon ${isUnread ? "notification-item-icon-unread" : "notification-item-icon-read"}`}
            >
              {/* {isUnread && <span className="notification-item-dot" />} */}
              <span
                className={`${iconSelect[e.Type] || "icon-notifications-bell"} ${e.Type === "A" && isUnread ? "notification-alert-icon" : ""}`}
              />
            </div>
            <div className="notification-item-content">
              <div className="notification-item-head">
                <span
                  className={`notification-item-reference ${isUnread ? "notification-item-reference-unread" : ""}`}
                >
                  {/* {e.Module} */}
                  {e.Type === "N" || e.Type === "A" ? (
                    e.Comment
                  ) : (
                    <>
                      <span className="userThatMentioned">{e.User}</span>{" "}
                      {this.props.t("mention_notification")} {e.Module}
                    </>
                  )}
                </span>
                {/* <span className="notification-item-date">{e.CreationDate}</span> */}
              </div>
              {/* <div
                className={`notification-item-message ${isUnread ? "notification-item-message-unread" : ""}`}
              >
                {e.Type === "A" ? (
                  e.Comment
                ) : (
                  <>
                    <span className="userThatMentioned">{e.User}</span>{" "}
                    {this.props.t("mention_notification")} {e.Module}
                  </>
                )}
              </div> */}
            </div>
          </div>
        </CardBody>
      </Card>
    );

    return (
      <div className="notification-list">
        {newNotify.length > 0 && (
          <div className="notification-section">
            <div className="notification-section-title">
              {this.props.t("alerts_notifications_new")}
            </div>
            {newNotify.map((item, index) =>
              renderNotifyItem(item, index, true),
            )}
          </div>
        )}
        {beforeNotify.length > 0 && (
          <div className="notification-section">
            <div className="notification-section-title">
              {this.props.t("alerts_notifications_before")}
            </div>
            {visibleBeforeNotify.map((item, index) =>
              renderNotifyItem(item, index, item.ReadComment === "0"),
            )}
            {isLoadingMoreBeforeNotify && beforeNotifySkeleton}
            {!showAllBeforeNotify &&
              !isLoadingMoreBeforeNotify &&
              beforeNotify.length > 10 && (
                <div className="notification-view-more-container">
                  <Button
                    color="primary"
                    onClick={this.handleShowMoreBeforeNotify}
                  >
                    {this.props.t("alerts_notifications_button_view_more")}
                  </Button>
                </div>
              )}
          </div>
        )}
      </div>
    );
  };

  toggleDrawer = (open) => (event) => {
    this.setState({ open });
  };

  toggleMenu = (e) => {
    if (e) e.preventDefault();
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }));
  };

  render() {
    let {
      redirect,
      searchValue,
      dataDrop,
      checkAll,
      cout,
      notify,
      open,
      isMobil,
      openDrop,
      openModal,
      collapsed,
      rolId,
      showExtraInfo,
    } = this.state;
    let countBadge = 0;

    for (let i = 0; i < notify.length; i++) {
      const e = notify[i];
      if (e.ReadComment === "0") countBadge = countBadge + 1;
    }

    if (redirect) return <Redirect to="/login" />;
    let acction;
    const { classes } = this.props;

    if (searchValue === "" || searchValue === undefined) {
    } else {
      acction = (
        <Link
          to={`/search/${encodeURIComponent(
            searchValue.replace(/[&\\#,+()$~%'":*?<>{}]/g, ""),
          )}`}
        >
          <button className="d-none" type="submit">
            Submit
          </button>
        </Link>
      );
    }
    if (dataDrop && dataDrop.length > 0) {
      dataDrop.map((data) => {
        data.value = data.value === "Entities" ? "Entidades" : data.value;
      });
    }
    return (
      <header className="topnavbar-wrapper">
        {/* START Top Navbar */}
        <nav className="navbar topnavbar">
          {/* START navbar header */}
          <div className="navbar-header">
            <a className="navbar-brand" href="/dashboard">
              <div className="brand-logo">
                <img
                  className="large-logo-header"
                  src={largeIMG}
                  alt="App Logo"
                />
              </div>
              <div className="brand-logo-collapsed">
                <img src={smallIMG} width={35} alt="App Logo" />
              </div>
            </a>
          </div>
          {/* END navbar header */}
          {/* START Left navbar */}
          <ul className="navbar-nav mr-auto flex-row">
            <li className="nav-item">
              {/* Collapse Button (Tablet & Desktop Only) */}
              <TriggerResize onClick={this.toggleMenu}>
                <ToggleState state="aside-collapsed">
                  <a
                    title={this.props.t("menu")}
                    href="#"
                    className="nav-link d-none d-md-block"
                  >
                    <i
                      className={`${
                        collapsed ? "icon-menu-abrir" : "icon-menu-cerrar"
                      } icons-topvar`}
                    ></i>
                  </a>
                </ToggleState>
              </TriggerResize>
              {/* Sidebar Toggle for Mobile */}
              <ToggleState state="aside-toggled" nopersist={true}>
                <a href=" " className="nav-link sidebar-toggle d-md-none">
                  <span className="icon-menu-abrir icons-topvar"></span>
                </a>
              </ToggleState>
            </li>

            {/* User Avatar Toggle */}
            <li
              className="nav-item d-none d-md-block"
              // className="nav-item"
            >
              <a
                title={this.props.t("user")}
                className="nav-link"
                onClick={this.toggleUserblock}
              >
                <i className="icon-my-profile icons-topvar"></i>
              </a>
            </li>

            {/* Filter Dropdown */}
            {!["8"].includes(rolId) && (
              <>
                <li className="nav-item">
                  <a
                    title={this.props.t("company_filter")}
                    className="nav-link"
                    onClick={() => {
                      this.setState({
                        openDrop: isMobil ? false : !openDrop,
                        openModal: isMobil ? !openDrop : false,
                      });
                    }}
                  >
                    <i className="icon-filter icons-topvar" />
                  </a>
                  {openDrop && (
                    <div className="filter-dropdown-content">
                      <div className="row">
                        <div className="col-10">
                          <InputGroup className=" align-items-center">
                            <Input
                              value={this.state.search}
                              placeholder={this.props.t("company")}
                              onChange={this.handleSearch}
                            />
                            <h5 className="selected-companies ml-2">
                              {this.props.t("selected_companies")}: {cout}
                            </h5>
                          </InputGroup>
                        </div>
                        <div className="col-2">
                          <Button color="secondary m-1" onClick={this.change}>
                            x
                          </Button>
                          <Button color="primary m-1" onClick={this.getCheck}>
                            ✓
                          </Button>
                        </div>
                      </div>
                      <div className="ui divider"></div>
                      <div style={{ overflowY: "scroll", height: "230px" }}>
                        <List as="ol">
                          <List.Item as="li" value="">
                            <Checkbox
                              checked={checkAll}
                              onChange={this.checkAll}
                              value={""}
                              style={{
                                color: "#000a2e",
                                margin: "2px",
                              }}
                            />
                            {this.props.t("select_all")}
                          </List.Item>
                        </List>
                        <div>
                          <List as="ol">
                            {dataDrop.map((e, index) => {
                              if (e.hidden) {
                                return <></>;
                              } else {
                                return (
                                  <div style={{ marginTop: "-10px" }}>
                                    <List.Item as="ol">
                                      {!openDrop ? (
                                        <></>
                                      ) : (
                                        e.data.map((f, ind) => {
                                          if (f.hidden) {
                                            return <></>;
                                          } else {
                                            return (
                                              <div
                                                className="squaredThree"
                                                style={{
                                                  fontWeight: "initial",
                                                  fontSize: "12px",
                                                  marginBottom: "10px",
                                                }}
                                              >
                                                <input
                                                  type="checkbox"
                                                  value={f.id}
                                                  onChange={() => {
                                                    this.checkClient(
                                                      index,
                                                      ind,
                                                    );
                                                  }}
                                                  id={"squaredThree" + ind}
                                                  name="check"
                                                  checked={f.check}
                                                />

                                                <label
                                                  htmlFor={"squaredThree" + ind}
                                                >
                                                  <em
                                                    style={{
                                                      color: "#F5F5F6",
                                                      margin: "2px",
                                                    }}
                                                    className="fas fa-check"
                                                  ></em>
                                                </label>
                                                <span
                                                  style={{
                                                    marginLeft: "12px",
                                                  }}
                                                >
                                                  {showExtraInfo ? (
                                                    <>
                                                      {/* <strong> */}
                                                      {f.value}{" "}
                                                      <span>
                                                        ({f.OwnerTeam})
                                                      </span>
                                                      {/* </strong> */}
                                                      <span
                                                        style={{
                                                          marginLeft: "6px",
                                                          color: "#9E9E9E",
                                                          fontSize: "11px",
                                                        }}
                                                      >
                                                        Id: {f.NIT}
                                                      </span>
                                                    </>
                                                  ) : (
                                                    f.value
                                                  )}
                                                </span>
                                              </div>
                                            );
                                          }
                                        })
                                      )}
                                    </List.Item>
                                    {index + 1 !== dataDrop.length ? (
                                      <Dropdown.Divider />
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                );
                              }
                            })}
                          </List>
                        </div>
                      </div>
                    </div>
                  )}
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-search-open="">
                    <i
                      className="icon-search icons-topvar"
                      title={this.props.t("quick_search")}
                    ></i>
                  </a>
                </li>
              </>
            )}
          </ul>

          <ul
            className="navbar-nav flex-row notifications-navicons-mobile"
            style={{ alignItems: "center" }}
          >
            {!["8"].includes(rolId) && (
              <li className="nav-item">
                <a title={this.props.t("notification")} className="nav-link">
                  <Badge
                    className="notification-bell-badge"
                    size="small"
                    color={"#ff1744"}
                    offset={[-35, 18]}
                    count={countBadge}
                    style={{
                      backgroundColor: "#ff1744",
                      color: "#ffffff",
                      fontWeight: "bold",
                      minWidth: "18px",
                      height: "18px",
                      lineHeight: "18px",
                      boxShadow: "0 0 0 2px #000a2e",
                    }}
                  >
                    <span className="notification-bell-trigger">
                      <i
                        className={`${notify.length > 0 ? "icon-alerts-notificationes-module" : "icon-alerts-notifications"} icons-topvar `}
                        onClick={this.toggleDrawer(true)}
                      />
                    </span>
                  </Badge>
                </a>
              </li>
            )}
            <li className="nav-item d-none d-md-block">
              {isMobil ? (
                <SwipeableDrawer
                  anchor="right"
                  open={open}
                  onClose={this.toggleDrawer(false)}
                  onOpen={this.toggleDrawer(true)}
                  disableSwipeToOpen={false}
                  ModalProps={{
                    keepMounted: true,
                  }}
                  sx={{
                    display: { xs: "block", sm: "none" },
                    "& .MuiDrawer-paper": {
                      boxSizing: "border-box",
                      width: window.innerWidth,
                    },
                  }}
                >
                  <div className="col-12 pt-3">
                    <div className=" justify-content-end">
                      <i
                        className="icon-cancel-1 navbar-form-close main-close-especial"
                        onClick={this.toggleDrawer(false)}
                      />
                    </div>
                    <div className="justify-content-center row notification-drawer-header">
                      <em
                        className={`notification-drawer-icon ${notify.length > 0 ? "styleIconExclamation icon-alerts-notificationes-module" : "styleIconExclamation icon-alerts-notifications"} `}
                      ></em>
                      <h3 className="titleNotify">
                        {this.props.t("notifications")}
                      </h3>
                    </div>
                    <div className=" justify-content-center ">
                      {notify.length <= 0 ? (
                        <Empty className="pt-5" />
                      ) : (
                        this.getNotify()
                      )}
                    </div>
                  </div>
                </SwipeableDrawer>
              ) : (
                <Drawer
                  anchor={"right"}
                  open={open}
                  classes={{ paper: classes.paper }}
                  onClose={this.toggleDrawer(false)}
                >
                  <div className="notification-drawer-header">
                    <span
                      className={`notification-drawer-icon ${notify.length > 0 ? "icon-alerts-notificationes-module" : "icon-alerts-notifications"}`}
                    />
                    <h3 className="titleNotify">
                      {this.props.t("notifications")}
                    </h3>
                  </div>
                  <div className="banerNotify">
                    {notify.length <= 0 ? (
                      <Empty style={{ padding: "3em 0px 0px 0px" }} />
                    ) : (
                      this.getNotify()
                    )}
                  </div>
                </Drawer>
              )}
            </li>
            <li className="nav-item d-none d-md-block displayCenter">
              <span
                onClick={() => this.props.onLogout()}
                title={this.props.t("logout")}
                className="nav-link"
              >
                <i className="icon-logout icons-topvar" />
              </span>
            </li>
            <li className="nav-item d-none d-md-block">
              <ToggleFullscreen
                title={this.props.t("fullscreen")}
                className="nav-link"
              />
            </li>
          </ul>
          <form className="navbar-form">
            <div className="form-group">
              <input
                className="form-control"
                type="text"
                onChange={this.handeInputData}
                placeholder={this.props.t("quick_search_instructions")}
              />
              <i className="icon-cancel-1 navbar-form-close main-close-especial" />
            </div>
            {acction}
          </form>
          <Modal size="fullscreen" open={openModal}>
            <Modal.Header>
              <div style={{ textAlign: "right", paddingBottom: "5px" }}>
                <Button color="secondary" onClick={this.change}>
                  x
                </Button>{" "}
                <Button color="primary" onClick={this.getCheck}>
                  ✓
                </Button>{" "}
              </div>

              <Row>
                <Col xs={12} md={7} lg={7} style={{ paddingBottom: "5px" }}>
                  <Input
                    value={this.state.search}
                    placeholder={this.props.t("company")}
                    onChange={this.handleSearch}
                  />
                </Col>
                <Col xs={12} md={5} lg={5} className="centerver">
                  <h5
                    style={{
                      color: "#0e0e0e",
                      fontWeight: "bold",
                    }}
                  >
                    {this.props.t("selected_companies")}: {cout}
                  </h5>
                </Col>
              </Row>
            </Modal.Header>
            <Modal.Content>
              <div
                style={{
                  overflowY: "scroll",
                  height: this.state.customHeight - 190,
                }}
                className="heightOtganizaciones"
              >
                <List as="ol">
                  <List.Item as="li" value="">
                    <Checkbox
                      checked={checkAll}
                      onChange={this.checkAll}
                      value={""}
                      style={{
                        color: "#000a2e",
                        margin: "2px",
                      }}
                    />
                    {this.props.t("select_all")}
                  </List.Item>
                </List>
                <div>
                  <List as="ol">
                    {dataDrop.map((e, index) => {
                      if (e.hidden) {
                        return <></>;
                      } else {
                        return (
                          <div style={{ marginTop: "-10px" }}>
                            <List.Item as="ol">
                              {!openModal ? (
                                <></>
                              ) : (
                                e.data.map((f, ind) => {
                                  if (f.hidden) {
                                    return <></>;
                                  } else {
                                    return (
                                      <div
                                        className="squaredThree"
                                        style={{
                                          fontWeight: "initial",
                                          fontSize: "12px",
                                          // marginBottom: "10px"
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          value={f.id}
                                          onChange={() => {
                                            this.checkClient(index, ind);
                                          }}
                                          id={"squaredThree" + ind}
                                          name="check"
                                          checked={f.check}
                                        />

                                        <label for={"squaredThree" + ind}>
                                          <em
                                            style={{
                                              color: "#F5F5F6",
                                              margin: "2px",
                                            }}
                                            className="fas fa-check"
                                          ></em>
                                        </label>
                                        <span style={{ marginLeft: "10px" }}>
                                          {showExtraInfo ? (
                                            <>
                                              {f.value}{" "}
                                              <span>({f.OwnerTeam})</span>
                                              <br></br>
                                              <span
                                                style={{
                                                  // marginLeft: "6px",
                                                  color: "#9E9E9E",
                                                  fontSize: "11px",
                                                }}
                                              >
                                                Id: {f.NIT}
                                              </span>
                                            </>
                                          ) : (
                                            f.value
                                          )}
                                        </span>
                                      </div>
                                    );
                                  }
                                })
                              )}
                            </List.Item>
                            {index + 1 !== dataDrop.length ? (
                              <Dropdown.Divider />
                            ) : (
                              <></>
                            )}
                          </div>
                        );
                      }
                    })}
                  </List>
                </div>
              </div>
            </Modal.Content>
          </Modal>
        </nav>
      </header>
    );
  }
}
const mapStateToProps = (state) => ({
  group_list: state.header.group_list,
  notify: state.header.notify,
  clients: state.header.clients,
  nit: state.header.nit,
  lang: state.header.lang,
});
const mapDispatchToProps = (dispatch) => ({
  SetNewListGroups: (new_group_list) =>
    dispatch(SetNewListGroups(new_group_list)),
});
export default withNamespaces()(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(withRouter(Header)),
  ),
);
